import { useMutation } from '@tanstack/vue-query';
import { dscvrApi } from '@/shared/api';

export const useGetOrCreateUserMutation = () => {
  return useMutation({
    mutationKey: ['get-or-create-user-mutation'],
    mutationFn: dscvrApi.verify.getOrCreateUser,
  });
};
